export const API_URL = process.env.VUE_APP_SERVER_URL;



// WEBPACK FOOTER //
// ./src/common/config.js